import { createAsyncActionType } from './index';

export const GET_HOME = createAsyncActionType('home', 'GET_HOME');
